import { ITlfActionSetRequestStatus, TlfContextProps } from "./interface";

/**
 * Replaces the current TLF request-status metadata.
 *
 * @param state - Current TLF context state.
 * @param action - Set-request-status action containing the next status object.
 * @returns Updated state with request status replaced.
 */
export const tlf_setTlfRequestStatus = (
  state: TlfContextProps,
  action: ITlfActionSetRequestStatus,
): TlfContextProps => ({
  ...state,
  requestStatus: action.requestStatus,
});
